import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import type { Project } from "@apis/memory/models";

import { useAppNavigation } from "../../../shared/hooks/useAppNavigation.ts";

interface ProjectCardProps {
  readonly project: Project;
}

export const ProjectCard: FC<ProjectCardProps> = ({ project }) => {
  const { goToMemoryProject } = useAppNavigation();

  return (
    <button
      className={`
        flex w-full items-center justify-between rounded-md border p-3 text-left
        hover:bg-muted
      `}
      onClick={bindArgs(goToMemoryProject, project.id)}
      type="button"
    >
      <span className="font-medium">{project.name}</span>
      <ChevronRight className="size-4 text-muted-foreground" />
    </button>
  );
};
